import React from "react";
import { Tooltip } from "react-tooltip";
import { FiInfo } from "react-icons/fi";
import "react-tooltip/dist/react-tooltip.css";

/**
 * Small info-button tooltip. Renders an (i) icon that shows `text` on hover/click.
 * Replaces unreliable native `title` tooltips. Newlines in `text` are preserved.
 */
let _seq = 0;

function InfoTip({ text }) {
  const id = React.useMemo(() => `infotip-${++_seq}`, []);
  return (
    <span style={{ display: "inline-flex", verticalAlign: "middle" }}>
      <span
        data-tooltip-id={id}
        data-tooltip-content={text}
        tabIndex={0}
        role="button"
        aria-label="Info"
        style={{
          marginLeft: 6,
          cursor: "help",
          color: "#888",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <FiInfo size={14} />
      </span>
      <Tooltip
        id={id}
        openOnClick={false}
        clickable
        style={{
          maxWidth: 300,
          whiteSpace: "pre-line",
          fontSize: 12,
          lineHeight: 1.4,
          zIndex: 9999,
          background: "#121212",
          color: "#fff",
        }}
      />
    </span>
  );
}

export default InfoTip;
